import _classCallCheck from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { number as locale } from './locale';
import isAbsent from './util/isAbsent';
import BaseSchema from './schema';

var isNaN = function isNaN(value) {
  return value != +value;
};

export function create() {
  return new NumberSchema();
}

var NumberSchema = /*#__PURE__*/function (_BaseSchema) {
  _inherits(NumberSchema, _BaseSchema);

  var _super = _createSuper(NumberSchema);

  function NumberSchema() {
    var _this;

    _classCallCheck(this, NumberSchema);

    _this = _super.call(this, {
      type: 'number'
    });

    _this.withMutation(function () {
      _this.transform(function (value) {
        var parsed = value;

        if (typeof parsed === 'string') {
          parsed = parsed.replace(/\s/g, '');
          if (parsed === '') return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings

          parsed = +parsed;
        }

        if (this.isType(parsed)) return parsed;
        return parseFloat(parsed);
      });
    });

    return _this;
  }

  _createClass(NumberSchema, [{
    key: "_typeCheck",
    value: function _typeCheck(value) {
      if (value instanceof Number) value = value.valueOf();
      return typeof value === 'number' && !isNaN(value);
    }
  }, {
    key: "min",
    value: function min(_min) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : locale.min;
      return this.test({
        message: message,
        name: 'min',
        exclusive: true,
        params: {
          min: _min
        },
        test: function test(value) {
          return isAbsent(value) || value >= this.resolve(_min);
        }
      });
    }
  }, {
    key: "max",
    value: function max(_max) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : locale.max;
      return this.test({
        message: message,
        name: 'max',
        exclusive: true,
        params: {
          max: _max
        },
        test: function test(value) {
          return isAbsent(value) || value <= this.resolve(_max);
        }
      });
    }
  }, {
    key: "lessThan",
    value: function lessThan(less) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : locale.lessThan;
      return this.test({
        message: message,
        name: 'max',
        exclusive: true,
        params: {
          less: less
        },
        test: function test(value) {
          return isAbsent(value) || value < this.resolve(less);
        }
      });
    }
  }, {
    key: "moreThan",
    value: function moreThan(more) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : locale.moreThan;
      return this.test({
        message: message,
        name: 'min',
        exclusive: true,
        params: {
          more: more
        },
        test: function test(value) {
          return isAbsent(value) || value > this.resolve(more);
        }
      });
    }
  }, {
    key: "positive",
    value: function positive() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : locale.positive;
      return this.moreThan(0, msg);
    }
  }, {
    key: "negative",
    value: function negative() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : locale.negative;
      return this.lessThan(0, msg);
    }
  }, {
    key: "integer",
    value: function integer() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : locale.integer;
      return this.test({
        name: 'integer',
        message: message,
        test: function test(val) {
          return isAbsent(val) || Number.isInteger(val);
        }
      });
    }
  }, {
    key: "truncate",
    value: function truncate() {
      return this.transform(function (value) {
        return !isAbsent(value) ? value | 0 : value;
      });
    }
  }, {
    key: "round",
    value: function round(method) {
      var _method;

      var avail = ['ceil', 'floor', 'round', 'trunc'];
      method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round'; // this exists for symemtry with the new Math.trunc

      if (method === 'trunc') return this.truncate();
      if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
      return this.transform(function (value) {
        return !isAbsent(value) ? Math[method](value) : value;
      });
    }
  }]);

  return NumberSchema;
}(BaseSchema);

export { NumberSchema as default };
create.prototype = NumberSchema.prototype; //
// Number Interfaces
//